import { api } from '@/shared/lib/api'
import { useQuery } from '@tanstack/react-query'

export const useGetTaskTree = (id: string, enabled: boolean = true) => {
    return useQuery({
        queryKey: ['task-tree', id],
        queryFn: () => api.task.getFolderTree(id),
        enabled: enabled && !!id,
        meta: {
            skipGlobalErrorHandler: true,
        },
    })
}
